package com.eladfinish.bible.contest.screens.pyramidCrossword

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.screens.pyramidCrossword.model.PyramidQuestion
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType
import com.eladfinish.bible.contest.ui.menus.actions.PyramidCrosswordToolbarAction
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.ImmutableMap
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.persistentMapOf

@Immutable
data class PyramidCrosswordState(
    val currentQuestions: ImmutableList<PyramidQuestion> = persistentListOf(),
    val userAnswers: ImmutableMap<Int, String> = persistentMapOf(), // Row index to user input string
    val rowValidation: ImmutableMap<Int, Boolean?> = persistentMapOf(), // Row index to correct/incorrect/null
    val focusedRowIndex: Int = 0,
    val focusedCellIndex: Int = 0,
    val isLoading: Boolean,
    val isGameFinished: Boolean,
    val isSkipReadMeChecked: Boolean,
    val dialogState: DialogState,
) : StateKt {

    @Stable
    sealed interface DialogState {
        data object None : DialogState
        data class Help(
            val helpContentType: HelpContentType,
            val isDontShowAgainChecked: Boolean,
        ) : DialogState

        data class Solutions(val content: String) : DialogState
    }
}

sealed interface PyramidCrosswordAction : ActionKt {
    data class PyramidsLoaded(
        val collections: List<List<PyramidQuestion>>,
    ) : PyramidCrosswordAction

    data class ToolbarClicked(val toolbarAction: PyramidCrosswordToolbarAction) : PyramidCrosswordAction
    data object LoadPyramids : PyramidCrosswordAction
    data object NextPyramid : PyramidCrosswordAction
    data class OnCellInput(val rowIndex: Int, val cellIndex: Int, val char: String) : PyramidCrosswordAction
    data class OnCellBackspace(val rowIndex: Int, val cellIndex: Int) : PyramidCrosswordAction
    data class OnCellFocused(val rowIndex: Int, val cellIndex: Int) : PyramidCrosswordAction
    data class ToggleHelp(val shouldShowNextTime: Boolean) : PyramidCrosswordAction
    data object HideDialog : PyramidCrosswordAction
    data object OnPrevRow : PyramidCrosswordAction
    data object OnNextRow : PyramidCrosswordAction
}

sealed interface PyramidCrosswordEffect : EffectKt {
    data object PlayCorrectSound : PyramidCrosswordEffect
    data object PlayIncorrectSound : PyramidCrosswordEffect
    data object PlayPageTurningSound : PyramidCrosswordEffect
    data object PlayBackspaceSound : PyramidCrosswordEffect
    data object VibrateShort : PyramidCrosswordEffect
    data object VibrateLong : PyramidCrosswordEffect
    data class ShowToast(val message: String) : PyramidCrosswordEffect

    data class GameCompleted(
        val toastMessage: String = "כל הכבוד!",
    ) : PyramidCrosswordEffect
}
